<template>
    <FormButton type="button" @click="confirmDeletion" title="Löschen">
        <TrashIcon class="w-5 h-5 text-white" />
    </FormButton>
    <ConfirmModal :show="confirmingDeletion" @close="confirmingDeletion = false">
        <template #title>Veranstaltung löschen</template>
        <template #content>
            <template v-if="event.date_id">
                Im ersten Schritt wird nur das Datum gelöscht.
                Wenn Sie die Veranstaltung vollständig löschen möchten,
                müssen Sie den Löschvorgang wiederholen.
            </template>
            <template v-else>
                Wollen Sie diese Veranstaltung wirklich löschen?
            </template>
        </template>
        <template #footer>
            <FormButton @click="confirmingDeletion = false">Abbrechen</FormButton>
            <FormButton class="ml-3" @click="doDelete">Löschen</FormButton>
        </template>
    </ConfirmModal>
</template>

<script setup>
import {ref} from "vue";
import {useForm} from "@inertiajs/vue3";
import FormButton from '@/Shared/Form/Button';
import ConfirmModal from '@/Shared/Confirm';
import { TrashIcon } from '@heroicons/vue/outline';

const props = defineProps({
    event: Object,
})
const form = useForm({})
const confirmingDeletion = ref(false)
const confirmDeletion = () => {
    confirmingDeletion.value = true
}
const doDelete = () =>
{
    let submitOptions = { onSuccess: () => { confirmingDeletion.value = false; } }

    if (props.event.date_id) {
        form.delete(route('manager.date.delete', [props.event.date_id]), submitOptions)
    } else if (props.event.slug) {
        form.delete(route('manager.event.delete', [props.event.slug]), submitOptions);
    }
}
</script>
